import Monster, { MonsterConfig } from "../Monster";
import IPositioner from "./MobGenerators/IPositioner";

// The mob generate interface 
export default interface IMobGenerate {
    IsActive: boolean;
    DurationActiveMinutes: number;
    DelaySecondUntilBegin: number;
    Mobs: MonsterConfig[];
    Positioner: IPositioner;

    AttachScene(scene: Phaser.Scene): void;
    PreLoad(scene: Phaser.Scene): void;
    Create(scene: Phaser.Scene): void;
    ShouldGenerate(elapsed: number): boolean;
    Generate(): Monster[];
}

export abstract class BasicMobGenerate implements IMobGenerate {
    abstract ShouldGenerate(elapsed: number): boolean;
    abstract Generate(): Monster[];

    IsActive: boolean;
    DurationActiveMinutes: number;
    DelaySecondUntilBegin: number;
    Mobs: MonsterConfig[];
    Positioner: IPositioner;

    protected mAttachedScene?: Phaser.Scene;

    constructor(scene?: Phaser.Scene) {
        this.mAttachedScene = scene;
    }

    public AttachScene(scene: Phaser.Scene) {
        this.mAttachedScene = scene;
    }

    PreLoad(scene: Phaser.Scene): void {
        if (this.mAttachedScene == null) {
            this.mAttachedScene = scene;
        }

        this.Mobs.forEach(mobConfig => {
            let path = `images/Monsters/${mobConfig.File?.FileName}`;

            const frameWidth = mobConfig.File?.FrameWidth ?? 128;
            const frameHeight = mobConfig.File?.FrameHeight ?? 128;
            scene.load.spritesheet(mobConfig.Name, path, { frameWidth, frameHeight });
        });
    }

    Create(scene: Phaser.Scene): void {
        // Use MobFileConfig
        /*
            "File": {
                "Type": "Spritesheet",
                "FileName": "PracticeHayTarget.png",
                "FrameStart": 0,
                "FrameEnd": 32,
                "Columns": 8,
                "Rows": 4
            }
        */
        this.Mobs.forEach(mobConfig => {

            let fileType = mobConfig.File?.Type;

            if (fileType == "Spritesheet") {

                let frameStart = mobConfig.File?.FrameStart;
                let frameEnd = mobConfig.File?.FrameEnd;
                scene.anims.create({
                    key: `anim_${mobConfig.Name}`,
                    frames: scene.anims.generateFrameNumbers(mobConfig.Name, { start: frameStart, end: frameEnd }),
                    repeat: -1
                });
            }
        });

    }

}

export interface IOneTimeMobGenerator extends IMobGenerate { }

export interface IIntervalMobGenerator extends IOneTimeMobGenerator {
    IntervalSpawnSeconds: number;
    TimesLimit: number; // Limit by number of times a mob spawns
}